import React from 'react';
import {JobPostingRequest} from '../../interface/JobPostingRequest';
import {SeniorFormData} from '../../interface/SeniorFormData';
import {useIosKeyboardOffset} from '../../hooks/useIosKeyboardOffset';
import {useIosInputAutoScroll} from '../../hooks/useIosInputAutoScroll';

interface JobPostingStep1Props {
    form: JobPostingRequest;
    seniors: SeniorFormData[];
    onFormChange: (updatedForm: JobPostingRequest) => void;
    onSeniorChange: (code: string) => void;
    onNextStep: () => void;
    onCancel: () => void;
}

const JobPostingStep1 = ({
                             form,
                             seniors,
                             onFormChange,
                             onSeniorChange,
                             onNextStep,
                             onCancel,
                         }: JobPostingStep1Props) => {
    const updateForm = (updates: Partial<JobPostingRequest>) => {
        onFormChange({...form, ...updates});
    };

    const keyboardHeight = useIosKeyboardOffset();
    useIosInputAutoScroll();

    return (
        <>
            <main className="container type_gray">
                <section>
                    <div className="inner-box">
                        <form className="form-box">
                            <div className="round-box">
                                <div className="round-header">
                                    <h3 className="round-tit">서비스 구분</h3>
                                </div>
                                <div className="round-body">
                                    <div className="form-item">
                                        <div className="radio-row">
    <span className="text-radio">
    <input
        type="radio"
        id="serviceType"
        name="serviceType"
        value={form.serviceType}
        defaultChecked
        disabled
    />
    <label htmlFor="serviceType">
        {form.serviceType === 'CARE' && '간병인 신청'}
        {form.serviceType === 'ESCORT' && '병원동행 신청'}
        {form.serviceType === 'HOUSEWORK' && '가사돌봄 신청'}
    </label>
    </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="round-box">
                                <div className="round-header">
                                    <h3 className="round-tit">어르신 정보</h3>
                                    <button
                                        type="button"
                                        className="reset-btn"
                                        onClick={() => {
                                            updateForm({
                                                seniorCode: '',
                                                elderName: '',
                                                gender: '',
                                                birthday: '',
                                                weight: '',
                                                height: '',
                                                longTermCareInsuranceNumber: '',
                                                relationship: '',
                                            });
                                        }}
                                    >
                                        초기화
                                    </button>
                                </div>
                                <div className="round-body">
                                    <div className="form-item">
                                        <div className="input-box">
                                            <select
                                                value={form.seniorCode || ''}
                                                onChange={e => onSeniorChange(e.target.value)}
                                            >
                                                <option hidden>어르신 정보 선택</option>
                                                {seniors.map(s => (
                                                    <option key={s.seniorCode} value={s.seniorCode}>
                                                        {s.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-item">
                                        <label className="input-tit">어르신 이름</label>
                                        <div className="line-input-box">
                                            <input
                                                type="text"
                                                value={form.elderName}
                                                onChange={e => updateForm({elderName: e.target.value})}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-item">
                                        <label className="input-tit">성별</label>
                                        <div className="line-input-box">
                                            <select
                                                value={form.gender}
                                                onChange={e => updateForm({gender: e.target.value})}
                                            >
                                                <option hidden>선택</option>
                                                <option value="M">남성</option>
                                                <option value="F">여성</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-item">
                                        <label htmlFor="birthday" className="input-tit">생년월일</label>
                                        <div className="line-input-box">
                                            <input
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                type="text"
                                                id="birthday"
                                                placeholder="yyyyMMdd"
                                                value={form.birthday}
                                                onChange={e => updateForm({birthday: e.target.value})}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-item">
                                        <label className="input-tit">키(cm)</label>
                                        <div className="line-input-box">
                                            <input
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                type="text"
                                                className="text-right"
                                                value={form.height}
                                                onChange={e => {
                                const num = e.target.value.replace(/[^0-9]/g, '');
                                updateForm({height: num === '' ? '' : String(parseInt(num, 10))});
                            }}
                                            />
                                            <span>cm</span>
                                        </div>
                                    </div>

                                    <div className="form-item">
                                        <label className="input-tit">체중(Kg)</label>
                                        <div className="line-input-box">
                                            <input
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                type="text"
                                                className="text-right"
                                                value={form.weight}
                                                onChange={e => {
                                const num = e.target.value.replace(/[^0-9]/g, '');
                                updateForm({weight: num === '' ? '' : String(parseInt(num, 10))});
                            }}
                                            />
                                            <span>kg</span>
                                        </div>
                                    </div>

                                    <div className="form-item">
                                        <label className="input-tit">장기요양보험 가입번호</label>
                                        <div className="line-input-box">
                                            <input
                                                type="text"
                                                className="text-right"
                                                value={form.longTermCareInsuranceNumber}
                                                onChange={e => updateForm({longTermCareInsuranceNumber: e.target.value})}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-item">
                                        <label className="input-tit">관계</label>
                                        <div className="line-input-box">
                                            <select
                                                value={form.relationship}
                                                onChange={e => updateForm({relationship: e.target.value})}
                                            >
                                                <option value="" hidden>선택</option>
                                                <option value="SPOUSE">배우자</option>
                                                <option value="PARENT">부모</option>
                                                <option value="CHILD">자녀</option>
                                                <option value="SIBLING">형제자매</option>
                                                <option value="COUSIN">친척</option>
                                                <option value="OTHER">기타</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </section>
            </main>

            <div
                className="bottom-btn"
                style={keyboardHeight > 0 ? {display: 'none'} : undefined}
            >
                <button type="button" className="btn cancel" onClick={onCancel}>
                    취소
                </button>
                <button type="button" className="btn confirm" onClick={onNextStep}>
                    다음
                </button>
            </div>
        </>
    );
};

export default JobPostingStep1;